import { store } from '../store/store'
import { digitalAppApi } from '../store/services/digitalAppApi'
import { buildAlbaranPrintParams } from './buildFacturaPrintParams'
import { buildAlbaranFilename } from './buildAlbaranFilename'
import { convertPdfBlobToJpegBlobs } from './convertPdfBlobToJpegBlob'

export const MAX_BULK_ALBARAN_DOWNLOADS = 50
export const ALBARAN_DOWNLOAD_FORMATS = ['pdf', 'jpeg']

const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms))

function triggerBlobDownload(blob, filename) {
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}


/** Descarga secuencial de albaranes del servidor (máx. 50 por lote) */
export async function downloadAlbaranPdfs(
  orders,
  priceWithIva,
  {
    onProgress,
    maxCount = MAX_BULK_ALBARAN_DOWNLOADS,
    tradeNameFallback,
    format = 'pdf',
  } = {},
) {
  const all = (orders || []).filter((o) => o?._id || o?.id)
  const limit = Math.min(maxCount, MAX_BULK_ALBARAN_DOWNLOADS)
  const list = all.slice(0, limit)
  const truncated = all.length > list.length
  const errors = []

  for (let i = 0; i < list.length; i++) {
    const order = list[i]
    const orderId = order._id || order.id
    const tradeName = order.tradeName || order.userAcc?.tradeName

    try {
      const queryArgs = buildAlbaranPrintParams(orderId, tradeName, priceWithIva)
      const result = await store
        .dispatch(digitalAppApi.endpoints.getAlbaranById.initiate(queryArgs))
        .unwrap()

      if (!(result instanceof Blob)) {
        throw new Error('Respuesta inválida del servidor')
      }

      if (format === 'jpeg') {
        const jpegPages = await convertPdfBlobToJpegBlobs(result)
        const totalPages = jpegPages.length

        for (let pageIndex = 0; pageIndex < jpegPages.length; pageIndex += 1) {
          const { pageNumber, blob } = jpegPages[pageIndex]

          triggerBlobDownload(
            blob,
            buildAlbaranFilename(order, tradeNameFallback, format, {
              pageNumber,
              totalPages,
            }),
          )

          if (pageIndex < jpegPages.length - 1) {
            await delay(150)
          }
        }
      } else {
        triggerBlobDownload(
          result,
          buildAlbaranFilename(order, tradeNameFallback, format),
        )
      }
      onProgress?.({ current: i + 1, total: list.length, order })
    } catch (err) {
      errors.push({ orderId, message: err?.message || 'Error desconocido' })
    }

    if (i < list.length - 1) {
      await delay(350)
    }
  }

  return {
    downloaded: list.length - errors.length,
    errors,
    truncated,
    skipped: truncated ? all.length - list.length : 0,
    attempted: list.length,
  }
}
